import React, { useState } from 'react'
import ReactJoyride, { STATUS, Step } from 'react-joyride'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'
import { useInclusionScoreAnalysis } from 'hooks/useInclusionScoreAnalysis'
import { OnboardingProps } from 'types/Onboarding.types'

import { Tooltip } from './Tooltip'

const OnboardingWithoutEB = (props: OnboardingProps) => {
    const { data } = useInclusionScoreAnalysis()

    const [steps] = useState([
        {
            target: '[data-joyride="inclusion-score-analysis-card"]',
            content:
                data?.pastSurveys?.length > 1
                    ? 'View your overall progress with your Inclusion Score, and click the arrow to expand and dive deeper!'
                    : "Measure your organization's overall inclusion efforts and click the arrow to view your results over time!",
            title: 'Inclusion Score',
            disableBeacon: true,
            placement: 'right-start',
        },
        {
            target: '[data-joyride="home-benchmark-switch"]',
            content: 'Adjust the sector you are benchmarking against',
            title: 'Benchmark Your Score',
            placement: 'right-start',
        },
        {
            target: '[data-joyride="home-diversity-table"]',
            content: 'Dive into representation across multiple levels and scroll down to analyze employee experience ',
            title: 'High-Level Breakdown',
            placement: 'top-start',
        },
        {
            target: '[data-joyride="right-content-panel"]',
            content: 'Stay up-to-date with important days of recognition, DEI events, trending resources, and more',
            title: 'Inclusive Content',
            placement: 'left-start',
        },
    ] as Step[])

    return (
        <ReactJoyride
            steps={steps}
            scrollOffset={300}
            continuous={true}
            locale={{ last: 'Close' }}
            styles={{
                options: {
                    primaryColor: '#6824ec',
                    overlayColor: 'rgba(60, 36, 120, 0.2)',
                },
                spotlight: {
                    borderRadius: 20,
                },
            }}
            tooltipComponent={Tooltip}
            floaterProps={{
                hideArrow: true,
            }}
            callback={(data) => {
                if (data.status === STATUS.FINISHED) {
                    localStorage.setItem('home_v2_onboarding_complete', '1')
                    props.onComplete()
                }
            }}
        />
    )
}

export const Onboarding = withErrorBoundary(OnboardingWithoutEB, {})
